import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class PtbDiscussionBumped extends EventPost {
  descriptionKey() {
    return 'floxum-payments.forum.pay-to-bump.description';
  }
  descriptionData() {
    return {
      count: this.attrs.post.content()?.length || 0,
    };
  }
  icon() {
    return 'fas fa-sort-numeric-up';
  }

  checkout() {
    const discussion = this.attrs.post.discussion().id();
    const handler = new Handler('ptb', {
      discussion,
    });

    handler.checkout();
  }

  footerItems() {
    const items = new ItemList();

    if (!app.session?.user) {
      items.add(
        'payToBump',
        <div className="Button Button--rounded" onclick={() => app.modal.show(LogInModal)}>
          {app.translator.trans('floxum-payments.forum.pay-to-bump.purchase-log-in')}
        </div>
      );
    } else {
      items.add(
        'payToBump',
        <Button onclick={() => this.checkout()} className="Button Button--rounded">
          {app.translator.trans('floxum-payments.forum.pay-to-bump.purchase-control')}
        </Button>
      );
    }

    return items;
  }
  actionItems() {
    return new ItemList();
  }
}
